import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaUser, FaLock, FaEnvelope, FaIdCard, FaShieldAlt } from 'react-icons/fa';

import Modal from 'Components/UI/Modal';
// import ModalFormField from 'Components/UI/ModalFormField';
import StatusMessage from 'Components/UI/StatusMessage';
import CommonModal from './CommonModal';
import { modalStyles } from 'utils/modalDesignSystem';
import { designTokens } from 'utils/designSystem';

import { getAdminDetail, addAdmin, idDuplicateCheck, editAdmin } from 'JS/API';
import {
  changeState,
  commonModalSetting,
  regularExpression,
  catchError,
} from 'JS/common';
import ModalFormField from './UI/FormField';

const AdminApplyModal = ({ setModal, mode, id }) => {
  const navigate = useNavigate();
  const [alert, setAlert] = useState('');
  const [alertBox, setAlertBox] = useState({
    mode: '',
    context: '',
    bool: false,
  });
  const [idCheck, setIdCheck] = useState('');
  const [render, setRender] = useState(false);
  const [originInfo, setOriginInfo] = useState({});
  const [info, setInfo] = useState({
    user_id: '',
    password: '',
    name: '',
    email: '',
    admin_role: 'admin',
  });
  let prevent = false;

  //= EmptyInput 확인
  const checkInputVal = () => {
    if (mode === 'apply' && !idCheck)
      return commonModalSetting(
        setAlertBox,
        true,
        'alert',
        '아이디 중복확인을 해 주세요.'
      );
    else if (mode === 'apply' && info?.password.trim() === '')
      return commonModalSetting(
        setAlertBox,
        true,
        'alert',
        '비밀번호를 입력해 주세요.'
      );
    else if (
      info?.password !== 'samplePw' &&
      !regularExpression('pw', info?.password)
    )
      return commonModalSetting(
        setAlertBox,
        true,
        'alert',
        '비밀번호 형식이 잘못되었습니다.<br/>비밀번호는 특수문자를 포함하여<br/>8 ~ 20자리만 가능합니다.'
      );
    else if (mode === 'apply' && info?.name.trim() === '')
      return commonModalSetting(
        setAlertBox,
        true,
        'alert',
        '성명을 입력해 주세요.'
      );
    else if (info?.email.trim() === '')
      return commonModalSetting(
        setAlertBox,
        true,
        'alert',
        '이메일을 입력해 주세요.'
      );
    else if (!regularExpression('email', info?.email))
      return commonModalSetting(
        setAlertBox,
        true,
        'alert',
        '이메일의 형식이 잘못되었습니다.<br/>다시 확인해 주세요.'
      );
    else return true;
  };

  //= 아이디 중복체크
  const duplicateCheck = async () => {
    if (info?.user_id?.trim() === '')
      return commonModalSetting(
        setAlertBox,
        true,
        'alert',
        '아이디를 입력해 주세요.'
      );
    else if (!regularExpression('id', info?.user_id))
      commonModalSetting(
        setAlertBox,
        true,
        'alert',
        '아이디 형식이 잘못되었습니다.<br/>아이디는 4자리에서 30자리까지 가능합니다.'
      );
    else {
      const result = await idDuplicateCheck(info?.user_id);
      setRender(true);
      if (typeof result === 'object') setIdCheck(true);
      else setIdCheck(false);
    }
  };

  //= 관리자 수정
  const adminEdit = async () => {
    if (checkInputVal()) {
      const query = {};
      if (info.admin_role !== originInfo.admin_role)
        query.admin_role = info.admin_role;
      if (info.email !== originInfo.email) query.email = info.email;
      if (info.password !== 'samplePw') query.password = info.password;
      const result = await editAdmin(id, query);
      if (typeof result === 'object') {
        setAlert('completeEdit');
        commonModalSetting(
          setAlertBox,
          true,
          'alert',
          '수정이 완료되었습니다.'
        );
      } else return await catchError(result, navigate, setAlertBox, setAlert);
    }
  };

  //= 관리자 등록
  const applyAdmin = async () => {
    if (checkInputVal()) {
      const query = { ...info };
      const result = await addAdmin(query);
      if (typeof result === 'object') {
        setAlert('completeApply');
        commonModalSetting(
          setAlertBox,
          true,
          'alert',
          '등록이 완료되었습니다.'
        );
      } else return await catchError(result, navigate, setAlertBox, setAlert);
    }
  };

  const getOriginInfo = async () => {
    if (prevent) return;
    prevent = true;
    setTimeout(() => {
      prevent = false;
    }, 200);
    const result = await getAdminDetail(id);
    if (typeof result === 'object') {
      const { admin_role, email, name, user_id } = result?.data?.data;
      setInfo(prev => {
        const clone = { ...prev };
        clone.admin_role = admin_role;
        clone.email = email;
        clone.name = name;
        clone.user_id = user_id;
        clone.password = 'samplePw';
        return clone;
      });
      setOriginInfo(result?.data?.data);
    }
  };

  useEffect(() => {
    if (mode === 'edit') getOriginInfo();
  }, []);

  return (
    <>
      <Modal
        title={mode === 'apply' ? '관리자 등록' : '관리자 수정'}
        onClose={() => setModal(false)}
        width="600px"
      >
        {/* 아이디 필드 */}
        <ModalFormField 
          label="아이디" 
          required={mode === 'apply'}
          fullWidth={mode === 'edit'}
        >
          {mode === 'edit' ? (
            <div style={{
              ...modalStyles.input,
              ...modalStyles.inputDisabled,
              display: 'flex',
              alignItems: 'center',
              gap: designTokens.spacing.sm
            }}>
              <FaIdCard size={14} />
              {info?.user_id}
            </div>
          ) : (
            <>
              <div style={modalStyles.inputGroup}>
                <div style={modalStyles.inputInGroup}>
                  <input
                    type="text"
                    style={modalStyles.input}
                    value={info?.user_id}
                    placeholder="아이디를 입력해 주세요."
                    onChange={(e) => {
                      setRender(false);
                      changeState(setInfo, 'user_id', e.target.value);
                    }}
                  />
                </div>
                <button
                  style={modalStyles.checkButton}
                  onClick={duplicateCheck}
                  onMouseEnter={(e) => e.target.style.backgroundColor = '#4b5563'}
                  onMouseLeave={(e) => e.target.style.backgroundColor = '#6b7280'}
                >
                  중복체크
                </button>
              </div>
              <StatusMessage
                type={idCheck ? 'success' : 'error'}
                show={render}
              >
                {idCheck 
                  ? '사용할 수 있는 아이디입니다.' 
                  : '사용할 수 없는 아이디입니다.'
                }
              </StatusMessage>
            </>
          )}
        </ModalFormField>

        {/* 비밀번호 필드 */}
        <ModalFormField label="비밀번호" required>
          <div style={{ position: 'relative' }}>
            <FaLock 
              size={14} 
              style={{
                position: 'absolute',
                left: designTokens.spacing.lg,
                top: '50%',
                transform: 'translateY(-50%)',
                color: designTokens.colors.text.tertiary
              }}
            />
            <input
              type="password"
              style={{
                ...modalStyles.input,
                paddingLeft: '40px'
              }}
              value={info?.password}
              placeholder="비밀번호를 입력해 주세요."
              onChange={(e) => changeState(setInfo, 'password', e.target.value)}
            />
          </div>
        </ModalFormField>

        {/* 권한 필드 */}
        <ModalFormField label="권한" required>
          <div style={{ position: 'relative' }}>
            <FaShieldAlt 
              size={14} 
              style={{
                position: 'absolute',
                left: designTokens.spacing.lg,
                top: '50%',
                transform: 'translateY(-50%)',
                color: designTokens.colors.text.tertiary,
                zIndex: 1
              }}
            />
            <select
              style={{
                ...modalStyles.select,
                paddingLeft: '40px'
              }}
              value={info?.admin_role}
              onChange={(e) => changeState(setInfo, 'admin_role', e.target.value)}
            >
              <option value="super_admin">최상위 관리자</option>
              <option value="admin">관리자</option>
            </select>
          </div>
        </ModalFormField>

        {/* 성명 필드 */}
        <ModalFormField label="성명" required={mode === 'apply'}>
          {mode === 'edit' ? (
            <div style={{
              ...modalStyles.input,
              ...modalStyles.inputDisabled,
              display: 'flex',
              alignItems: 'center',
              gap: designTokens.spacing.sm
            }}>
              <FaUser size={14} />
              {info?.name}
            </div>
          ) : (
            <div style={{ position: 'relative' }}>
              <FaUser 
                size={14} 
                style={{
                  position: 'absolute',
                  left: designTokens.spacing.lg,
                  top: '50%',
                  transform: 'translateY(-50%)',
                  color: designTokens.colors.text.tertiary
                }}
              />
              <input
                type="text"
                style={{
                  ...modalStyles.input,
                  paddingLeft: '40px'
                }}
                value={info?.name}
                placeholder="성명을 입력해 주세요."
                onChange={(e) => changeState(setInfo, 'name', e.target.value)}
              />
            </div>
          )}
        </ModalFormField>

        {/* 이메일 필드 */}
        <ModalFormField label="이메일" required>
          <div style={{ position: 'relative' }}>
            <FaEnvelope 
              size={14} 
              style={{
                position: 'absolute',
                left: designTokens.spacing.lg,
                top: '50%',
                transform: 'translateY(-50%)',
                color: designTokens.colors.text.tertiary
              }}
            />
            <input
              type="email"
              style={{
                ...modalStyles.input,
                paddingLeft: '40px'
              }}
              value={info?.email}
              placeholder="이메일을 입력해 주세요."
              onChange={(e) => changeState(setInfo, 'email', e.target.value)}
            />
          </div>
        </ModalFormField>

        {/* 제출 버튼 */}
        <ModalFormField fullWidth>
          <button
            style={modalStyles.submitButton}
            onClick={mode === 'edit' ? adminEdit : applyAdmin}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#2563eb'}
            onMouseLeave={(e) => e.target.style.backgroundColor = '#3b82f6'}
          >
            {mode === 'edit' ? '수정' : '등록'}
          </button>
        </ModalFormField>
      </Modal>

      {alertBox.bool && (
        <CommonModal
          setModal={setAlertBox}
          modal={alertBox}
          okFn={() => {
            if (
              alert === 'completeApply' ||
              alert === 'completeDelete' ||
              alert === 'completeEdit'
            )
              setModal(false);
            else if (alert === 'logout') navigate('/');
            else return;
          }}
        />
      )}
    </>
  );
};

export default AdminApplyModal;